import getListWithId from 'utils/getListWithId';
import { FormattedMessage } from 'utils/intl';

import { Item as WhyTrustUsItem } from '../components/WhyTrustUs';
import messages from './AboutUsCommon.messages';

export const getItems = ([coconName, coconStartYear, dellowoStartYear, clients, devices]: string[]): WhyTrustUsItem[] =>
  getListWithId([
    {
      title: coconStartYear,
      subtitle: (
        <FormattedMessage
          {...messages.startCocon}
          values={{
            name: coconName,
            during: new Date().getFullYear() - Number(coconStartYear),
          }}
        />
      ),
    },
    {
      title: dellowoStartYear,
      subtitle: (
        <FormattedMessage
          {...messages.dellowo}
          values={{ during: new Date().getFullYear() - Number(dellowoStartYear) }}
        />
      ),
    },
    {
      title: clients,
      subtitle: <FormattedMessage {...messages.clients} />,
    },
    {
      title: devices,
      subtitle: <FormattedMessage {...messages.devices} values={{ year: new Date().getFullYear() - 1 }} />,
    },
  ]);
